import { styled } from '@mui/system'
import { TTheme } from '@/core/theme'

export const CalloutWrapper = styled('div')<{ theme?: TTheme }>`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    padding: 12px 16px;
    border-radius: 8px;
    background-color: ${({ theme }) =>
        theme.colors.semantic.backgroundSecondary};
`

export const IconBadge = styled('div')<{ theme?: TTheme }>`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-color: ${({ theme }) => theme.colors.greys[0]};
    color: ${({ theme }) => theme.colors.primary[400]};
`

export const CalloutContent = styled('div')`
    display: flex;
    align-items: center;
    gap: 12px;
    min-width: 0;
`

export const CalloutText = styled('div')`
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
`

export const OpenChatButton = styled('button')<{ theme?: TTheme }>`
    display: inline-flex;
    align-items: center;
    gap: 6px;
    border: none;
    background: transparent;
    cursor: pointer;
    padding: 4px 8px;
    white-space: nowrap;
    color: ${({ theme }) => theme.colors.primary[900]};
`
